export default __webpack_public_path__ + "static/media/backward.6cd01f92.svg";